// extracted by mini-css-extract-plugin
export default {"container":"Box_container__x9pmm","title-container":"Box_title-container__k5pDP","title":"Box_title__RDlX2","status":"Box_status__0nJ4k","img":"Box_img__soo6V"};